import script from "./column-list.vue?vue&type=script&setup=true&lang=js"
export * from "./column-list.vue?vue&type=script&setup=true&lang=js"

import "./column-list.vue?vue&type=style&index=0&id=a516bbb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a516bbb2"]])

export default __exports__